module.exports = __webpack_public_path__ + "6368fc3cf0b6c2f85054c101483f5210.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/misc/fullscreen.svg
// module id = 28
// module chunks = 0